export default "__VITE_ASSET__DP$fl4m1__"